import React from 'react'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

import { Badge } from '../Badge'
import { getLoyaltyType } from '../utils/loyalty'
import { LOYALTY_SCHEMA as txt } from '../BadgeContent'
import { useHostCustomer } from '../../../../hooks/useHostCustomer'

dayjs.extend(relativeTime)

function LoyaltyBadge(): JSX.Element {
  const { isAfg, legacyCustomer, afgCustomer, hostLoading } = useHostCustomer()
  const legacyAcctOpenDate = legacyCustomer?.customer?.accountOpeningDate
  const afgAcctOpenDate = afgCustomer?.data?.sinceDate
  const acctOpenDate = isAfg ? afgAcctOpenDate : legacyAcctOpenDate
  const type = getLoyaltyType(acctOpenDate ?? '')
  const memberSinceYear = dayjs(acctOpenDate).year() || ''

  return (
    <Badge
      data-testid="loyalty-badge"
      status={hostLoading}
      icon={txt.icon[type]}
      heading={txt.heading[type]}
      desc={`${txt.desc[type]} ${memberSinceYear}${
        type === 'FALLBACK' ? '' : '.'
      }`}
    />
  )
}

export { LoyaltyBadge }
